module.exports = __webpack_public_path__ + "img/Westminster_Foundation_Website_Header_Logo_WF_Logo.e493ee7c.svg";